// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const GoalZenOutline = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 96 96"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		{...props}
	>
		<defs>
			<path
				d="M41.448 12.716c-3.797.002-6.635 1.841-6.635 3.486 0 1.644 2.838 3.483 6.635 3.484 3.797 0 6.634-1.84 6.634-3.485 0-1.645-2.837-3.485-6.634-3.485m1.468 13.836c-14.538 0-16.542 2.256-16.542 4.692 0 3.78 5.565 5.697 16.542 5.697 7.912 0 13.491-.33 17.558-1.04 4.897-.857 6.641-2.135 6.641-3.047 0-2.57-9.427-6.302-24.199-6.302M60.883 43.51c-14.75 0-27.791 2.786-31.714 6.775-.732.745-1.081 1.468-1.07 2.212.105 6.117 24.701 6.117 32.784 6.117 16.693-.002 22.617-4.428 22.617-8.22 0-4.439-8.032-6.884-22.617-6.885M38.989 65.174c-17.082.001-26.489 2.942-26.489 8.282 0 7.254 14.269 9.828 26.489 9.828 26.097 0 38.255-4.388 38.255-7.354 0-4.15-17.507-10.756-38.255-10.756m0 22.11c-19.092 0-30.489-5.17-30.489-13.828 0-11.025 18.495-12.153 27.733-12.268-7.209-1.324-12.052-3.845-12.133-8.62-.031-1.847.715-3.557 2.216-5.084 3.177-3.232 9.569-5.319 16.727-6.543h-.127c-5.081 0-20.542-.002-20.542-9.698 0-6.2 6.338-8.008 13.806-8.508-3.229-1.273-5.367-3.695-5.367-6.534 0-4.196 4.671-7.484 10.635-7.485 5.963 0 10.634 3.289 10.634 7.486 0 2.783-2.055 5.166-5.179 6.456 10.066.521 24.212 3.06 24.212 10.197 0 3.456-2.989 5.497-8.199 6.664 7.928.077 24.584.953 24.584 10.877 0 3.673-2.594 12.218-26.617 12.218-1.765 0-3.525-.005-5.267-.026 13.398 2.206 25.628 6.898 25.628 13.342 0 4.182-4.695 7.154-14.356 9.088-7.3 1.462-17.209 2.266-27.899 2.266"
				id="GoalZenOutline_tsx__a"
			/>
		</defs>
		<use fill="#FFF" xlinkHref="#GoalZenOutline_tsx__a" fillRule="evenodd" />
	</svg>
);
export default GoalZenOutline;
